import React from "react";
import styles from "./Error.module.scss";

interface ErrorProps {
  message?: string;
}

const ErrorModal: React.FC<ErrorProps> = ({ message = "Bir hata oluştu" }) => {
  return (
    <div className={styles.errorContainer}>
      <img src="/assets/logo.png" alt="logo" />
      <div className={styles.errorContent}>
        <div className={styles.errorIcon}>⚠️</div>
        <h2>Üzgünüz!</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ErrorModal;
